export default class TranslatedContend {
    constructor() {
        const wizardDataElem = document.querySelector("[data-wizard]");
        this.translations = JSON.parse(wizardDataElem.getAttribute('data-content'));
    }

    getTranslations() {
        return this.translations.content;
    }
}
